import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
    feedbackDuration: { type: Number, default: 1500 },
    successText: { type: String, default: "Copied!" },
    // "text" swaps the trigger's own label; "icon" leaves the markup alone and
    // only flips the copied class, so an icon-only trigger keeps its <img>.
    feedback: { type: String, default: "text" }
  }

  static targets = ["source", "trigger", "status"]

  copy(event) {
    event.preventDefault()

    const text = this.hasContentValue
      ? this.contentValue
      : this.hasSourceTarget
        ? this.sourceTarget.textContent.trim()
        : ""

    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback()
    }).catch(() => {
      this.fallbackCopy(text)
    })
  }

  showFeedback() {
    const trigger = this.hasTriggerTarget ? this.triggerTarget : this.element
    trigger.classList.add("copied")
    this.announce(this.successTextValue)

    if (this.feedbackValue === "icon") {
      this.resetAfterFeedback(() => trigger.classList.remove("copied"))
      return
    }

    const originalText = trigger.textContent
    trigger.textContent = this.successTextValue

    this.resetAfterFeedback(() => {
      trigger.textContent = originalText
      trigger.classList.remove("copied")
    })
  }

  resetAfterFeedback(reset) {
    clearTimeout(this.feedbackTimeout)
    this.feedbackTimeout = setTimeout(() => {
      reset()
      this.announce("")
    }, this.feedbackDurationValue)
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy")
      this.showFeedback()
    } catch {
      console.error("Clipboard: copy failed")
    } finally {
      document.body.removeChild(textarea)
    }
  }
}
